@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.skeletonParagraph {
  li {
    margin-top: 0 !important;
    height: 12px !important;
    border-radius: 20px !important;
  }
}
